module.exports = __webpack_public_path__ + "static/media/upload-document-ruledpage-mobile.c1b783aa.png";